import configs from '@/config';
import axios from 'axios'


//使用post请求时，参数需要放在data中，
// request({
//   url:"",
//   method:"POST",
//   data:{
//     id:1,
//     name:2
//   }
// })
export function request(config) {
  // 1.创建axios的实例
  const instance = axios.create({
    // headers: {
    //   'Content-Type': 'application/json',
    // },
    baseURL: config.url.indexOf("http") >= 0 ? "" : process.env.NODE_ENV === 'production' ? baseUrl : configs.devBaseUrl,
    timeout: 60000
  })
  //根据具体情况调用请求头
  // instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  instance.defaults.headers.post['Content-Type'] = 'application/json';
  // 2.axios的拦截器
  // 2.1.请求拦截的作用
  instance.interceptors.request.use(config => {
    return config
  }, err => {
    Promise.reject(err);
  })
  // 2.2.响应拦截
  instance.interceptors.response.use(res => {
    if (res.status === 200) {
      if (res.data.code === 0) {
        return Promise.resolve(res.data)
      } else {
        // if (res.config.url.indexOf("UsersApi") >= 0) {
        //   return Promise.resolve(res.data)
        // }
        if (res.config.url.indexOf("GetById") >= 0) {
          router.replace({
            path: '/notFound',
            query: {
              redirect: router.currentRoute.fullPath
            }
          });
        }
      }
    }
    // return res.data
  }, err => {
    Promise.reject(err);
  })
  // 3.发送真正的网络请求
  return instance(config)
}